import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../lib/api';
import { PageHead, Section, Spinner, ErrorNote, Empty, useAsync } from '../components/ui';
import { GroupCard } from '../components/cards';
import { unenrolledFirst } from '../lib/sort';
import { useRole } from '../app/RoleContext';
import { fromHere } from '../components/BackCrumb';

export default function GroupsPage() {
  const navigate = useNavigate();
  const { canManageGroups } = useRole();
  const [creating, setCreating] = useState(false);
  const { loading, error, data, reload } = useAsync(
    () => api.browseGroups().then((g) => (Array.isArray(g) ? g : [])),
    []
  );

  // Draft-and-open pattern (mirrors CoursesAdminPage). Publisher lands on
  // the manage screen where AssociationTabs is available immediately.
  const newGroup = async () => {
    setCreating(true);
    try {
      const created = await api.createGroup({ name: 'Untitled group', priceCents: 0, draft: true /* hidden until first Save */ });
      navigate(`/leader/group/${created.id}?created=1`, fromHere('/groups', 'Groups'));
    } catch (e) { alert(e.message); setCreating(false); }
  };

  return (
    <div className="page">
      <PageHead
        icon="👥"
        title="Groups"
        sub="Browse and register to join groups"
        actions={canManageGroups
          ? <button className="btn btn-primary" disabled={creating} onClick={newGroup}>{creating ? 'Creating…' : '+ New group'}</button>
          : null}
      />
      {loading ? <Spinner /> : error ? <ErrorNote error={error} onRetry={reload} /> : (
        <Section>
          {data.length === 0 ? <Empty>You're not in any groups yet.</Empty> : (
            <div className="card-grid">
              {unenrolledFirst(data, 'joined').map((g) => <GroupCard key={g.id} group={g} />)}
            </div>
          )}
        </Section>
      )}
    </div>
  );
}
